import { render, staticRenderFns } from "./ProductList2.vue?vue&type=template&id=66e3afc0&"
import script from "./ProductList2.vue?vue&type=script&lang=js&"
export * from "./ProductList2.vue?vue&type=script&lang=js&"
import style0 from "./ProductList2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports